import { LocationCategoryAPI } from '@/clients/location/location.category.api'
export default {
    namespaced: true,
    state: {
        addPop: false,
        editPop: false,
        editObj: {},
        threshholdPop: false,
        threshholdObj: {},
        productPop: false,
        productObj: {},
        list: [],
        categoryObject: {},// key:value => id_of_category: name_of_Category
        assignedList: []
    },
    getters: {
        addPop: state => state.addPop,
        editPop: state => state.editPop,
        editObj: state => state.editObj,
        threshholdPop: state => state.threshholdPop,
        threshholdObj: state => state.threshholdObj,
        productPop: state => state.productPop,
        productObj: state => state.productObj,
        list: state => state.list,
        assignList: state => state.assignedList,
        categoryObject: state => state.categoryObject
    },
    mutations: {
        mutateAddPop(state, data) {
            state.addPop = data
            // If add is on edit is false
            state.editPop = false
            state.threshholdPop = false
        },
        mutateEditPop(state, data) {
            state.editPop = data
            // If Edit is on add is false
            state.addPop = false
            state.threshholdPop = false
        },
        mutateEditObj(state, data) {
            state.editObj = data
        },
        mutateList(state, data) {
            state.list = data
        },
        mutateAssignedList(state, data) {
            state.assignedList = data
        },
        mutateThreshholdPop(state, data) {
            state.threshholdPop = data
            // If Edit is on add is false
            state.addPop = false
            state.editPop = false
        },
        mutateThreshholdObj(state, data) {
            state.threshholdObj = data
        },
        mutateProductPop(state, data) {
            state.productPop = data
        },
        mutateProductObj(state, data) {
            state.productObj = data
        },
        clearLocationCategoryState(state) {
            Object.assign(state, require('./reset/locationcategory.json'))
        },
        mutateCategoryObject(state,data) {
            state.categoryObject = data
        }
    },
    actions: {
        setAddPop(context, data) {
            context.commit('mutateAddPop', data)
        },
        setEditPop(context, data) {
            context.commit('mutateEditPop', data)
        },
        setEditObj(context, data) {
            context.commit('mutateEditObj', data)
        },
        setThreshholdPop(context, data) {
            context.commit('mutateThreshholdPop', data)
        },
        setThreshholdObj(context, data) {
            context.commit('mutateThreshholdObj', data)
        },
        setProductPop(context, data) {
            context.commit('mutateProductPop', data)
        },
        setProductObj(context, data) {
            context.commit('mutateProductObj', data)
        },
        async assignedList(context, locationProductId) {
            const { data: { payload } } = await LocationCategoryAPI.getFeaturedCategory(locationProductId)
            context.commit('mutateAssignedList', payload)
        },
        async setList(context, locationId) {
            const { data: { payload } } = await LocationCategoryAPI.fetch(locationId)
            context.commit('mutateList', payload)
        }
    }
}
